import { Divider, MenuItem } from "@mui/material";
import { ContentCopy as ContentCopyIcon, Edit as EditIcon, Delete as DeleteIcon, ForkLeft as ForkLeftIcon, Style as StyleIcon } from "@mui/icons-material";
import Add from "./Add";
import Edit from "./Edit";
import Remove from "./Remove";
import Tags from "./Tags";
import Variants from "./Variants";
import AddBulk from "./AddBulk";
import CSV from "./AddCSV";
import Copy from "./Copy";

export function ActionsDialogPage({ open, close, menu, subcategory, columns, instance, reportAction }) {
  return (<>
    <Add
      open={open === 1}
      close={close}
      menu={menu}
      subcategory={subcategory}
      reportAction={reportAction} />
    <Edit
      open={open === 2}
      close={close}
      menu={menu}
      subcategory={subcategory}
      instance={instance}
      reportAction={reportAction} />
    <Remove
      open={open === 3}
      close={close}
      subcategory={subcategory}
      instance={instance}
      reportAction={reportAction} />
    <Copy
      open={open === 4}
      close={close}
      menu={menu}
      subcategory={subcategory}
      instance={instance}
      reportAction={reportAction} />
    <Tags
      open={open === 5}
      close={close}
      instance={instance}
      reportAction={reportAction} />
    <Variants
      open={open === 6}
      close={close}
      menu={menu}
      instance={instance}
      columns={columns}
      reportAction={reportAction} />
    <AddBulk
      open={open === 7}
      close={close}
      menu={menu}
      subcategory={subcategory}
      reportAction={reportAction} />
    <CSV
      open={open === 8}
      close={close}
      menu={menu}
      subcategory={subcategory}
      reportAction={reportAction} />
  </>)
}

export function ActionsMenuPage({ t, action }) {
  // 2: edit, 3: delete
  return (<>
    <MenuItem onClick={() => { action(2) }} disableRipple>
      <EditIcon /> {t('button_text_edit')}
    </MenuItem>
    <MenuItem onClick={() => { action(4) }} disableRipple>
      <ContentCopyIcon /> {t('button_text_copy')}
    </MenuItem>
    <MenuItem onClick={() => { action(5) }} disableRipple>
      <StyleIcon /> {t('button_text_tags')}
    </MenuItem>
    <MenuItem onClick={() => { action(6) }} disableRipple>
      <ForkLeftIcon /> {t('button_text_variants')}
    </MenuItem>
    <Divider sx={{ my: 0.5 }} />
    <MenuItem onClick={() => { action(3) }} disableRipple>
      <DeleteIcon color="error" /> {t('button_text_delete')}
    </MenuItem>
  </>)
}